<template>
  <div>
    <b-tabs vertical nav-wrapper-class="nav-vertical">
      <b-tab title="Bills of Materials">
        <DocumentUpload
          @uploadFiles="(files) => uploadFiles(files, 'BOM')"
          :documentDetails="documentDetailsBOM"
          @deleteFile="(id) => deleteFile(id, 'BOM')"
          @downloadFile="(id, fileName) => downloadFile(id, fileName, 'BOM')"
        />
      </b-tab>
      <b-tab title="Operation Steps">
        <DocumentUpload
          @uploadFiles="(files) => uploadFiles(files, 'Operation')"
          :documentDetails="documentDetailsOps"
          @deleteFile="(id) => deleteFile(id, 'Operation')"
          @downloadFile="
            (id, fileName) => downloadFile(id, fileName, 'Operation')
          "
        />
      </b-tab>
      <b-tab title="Cost">
        <DocumentUpload
          @uploadFiles="(files) => uploadFiles(files, 'Cost')"
          :documentDetails="documentDetailsCost"
          @deleteFile="(id) => deleteFile(id, 'Cost')"
          @downloadFile="(id, fileName) => downloadFile(id, fileName, 'Cost')"
        />
      </b-tab>
      <b-tab title="Quality Control">
        <DocumentUpload
          @uploadFiles="(files) => uploadFiles(files, 'Quality')"
          :documentDetails="documentDetailsQC"
          @deleteFile="(id) => deleteFile(id, 'Quality')"
          @downloadFile="
            (id, fileName) => downloadFile(id, fileName, 'Quality')
          "
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab, BCardText } from "bootstrap-vue";
import DocumentUpload from "../../../../component/DocumentUpload.vue";
import { mapActions, mapGetters } from "vuex";
import { customSwal, customError } from "@/libs/customFn";
export default {
  props: {
    id: {
      type: String,
    },
  },
  components: {
    BCardText,
    BTabs,
    BTab,
    DocumentUpload,
  },
  data() {
    return {
      documentDetailsBOM: {
        isDelete: false,
        documentList: [],
      },
      documentDetailsOps: {
        isDelete: false,
        documentList: [],
      },
      documentDetailsCost: {
        isDelete: false,
        documentList: [],
      },
      documentDetailsQC: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  computed: {
    ...mapGetters("jobcardModule", {
      jobFile: "jobFile",
      jobcardsFiles: "jobcardsFiles",
      jobcardsFile: "jobcardsFile",
    }),
  },
  methods: {
    ...mapActions("jobcardModule", [
      "addJobcardFileAction",
      "addMultipleJobcardFileAction",
      "getJobcardFileAction",
      "removeJobcardFileAction",
      "downloadJobcardFileAction"
    ]),
    // Update documentDetails based on type
    updateDocumentDetails(type) {
      const filteredDocs = this.jobFile.data.filter((doc) => doc.type === type);
      if (type === "BOM") {
        this.documentDetailsBOM.documentList = filteredDocs;
        this.documentDetailsBOM.isDelete = true;
      } else if (type === "Operation") {
        this.documentDetailsOps.documentList = filteredDocs;
        this.documentDetailsOps.isDelete = true;
      } else if (type === "Cost") {
        this.documentDetailsCost.documentList = filteredDocs;
        this.documentDetailsCost.isDelete = true;
      } else if (type === "Quality") {
        this.documentDetailsQC.documentList = filteredDocs;
        this.documentDetailsQC.isDelete = true;
      }
    },
    async uploadFiles(selectedFiles, type) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) are being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const referenceId = this.id;
      const multipleFormData = new FormData();

      selectedFiles.forEach((file) => {
        multipleFormData.append("Files", file);
      });
      multipleFormData.append("ReferenceId", referenceId);
      multipleFormData.append("Type", type);

      try {
        if (selectedFiles.length > 1) {
          await this.addMultipleJobcardFileAction(multipleFormData);
          customSwal("Your files have been successfully uploaded.");
        } else if (selectedFiles.length === 1) {
          const formData = new FormData();
          formData.append("File", selectedFiles[0]);
          formData.append("ReferenceId", referenceId);
          formData.append("Type", type);
          await this.addJobcardFileAction(formData);
          customSwal("Your file has been successfully uploaded.");
        }
        // Update document list for the relevant type
        await this.getJobcardFileAction(this.id);
        this.updateDocumentDetails(type);
      } catch (error) {
        customError(error);
      } finally {
        loader.close();
      }
    },

    // Generalized function to delete file based on document type
    async deleteFile(id, type) {
      console.log("deleteFile enter");
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await this.removeJobcardFileAction(id)
        .then((response) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customSwal("Your file has been deleted.");
        })
        .catch((error) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customError(error);
        });

        // Update document list for the relevant type
        await this.getJobcardFileAction(this.id);
        this.updateDocumentDetails(type);
    },

    // Generalized function to download file based on document type
    async downloadFile(id, fileName, type) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await this.downloadJobcardFileAction(id);
        console.log("response from action",response)
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        customError("Failed to download the file. Please try again.");
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getJobcardFileAction(this.id);
    this.updateDocumentDetails("BOM");
    this.updateDocumentDetails("Operation");
    this.updateDocumentDetails("Cost");
    this.updateDocumentDetails("Quality");
  },
};
</script>

<style>
.nav-pills .nav-link,
.nav-tabs .nav-link {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
